import React from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import ArrowForward from "@mui/icons-material/ArrowForward";
const biryani = `${process.env.PUBLIC_URL}/chickenBiryani-480.webp`;

function HomeOfferSection() {
  const reduceMotion = useReducedMotion();

  return (
    <section className="home-offers" aria-labelledby="home-offer-title">
      <motion.div
        className="home-offer-banner"
        initial={reduceMotion ? false : { opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <div className="home-offer-copy">
          <p className="home-offer-eyebrow">A little extra happiness</p>
          <h2 id="home-offer-title">Big flavor.<br /><em>Delicious offers.</em></h2>
          <p>Discover our latest offers and find a little more to love with every bite.</p>
          <Link className="home-offer-button" to="/offer">
            Explore Offers <ArrowForward aria-hidden="true" />
          </Link>
        </div>
        <div className="home-offer-art" aria-hidden="true">
          <span className="home-offer-ring" />
          <img src={biryani} alt="" loading="lazy" />
          <span className="home-offer-note">Good food.<br />Happy moments.</span>
        </div>
      </motion.div>
    </section>
  );
}

export default React.memo(HomeOfferSection);
